import { ContactsSegmentsResponse } from '../../../sic-lib/api/segments/types/ContactsSegmentsResponse';
import { RequestStatus } from '../../../sic-lib/enums/RequestStatus';
import { ListItem } from '../../../sic-lib/types/Lists';
import { View } from '../../../sic-lib/types/View';
import { useAppSelector } from '../../../store/hooks';
import PageStatus from '../../Navigation/PageStatus/PageStatus';
import ContactsTableHeader from './ContactsTableHeader/ContactsTableHeader';
import ContactsTableRow from './ContactsTableRow/ContactsTableRow';
import TablePagination from './TablePagination/TablePagination';

interface Props {
    appliedList: ListItem | ContactsSegmentsResponse;
    appliedView: View;
    hasMediumScreen: boolean;
}

export default function ContactsTable({ appliedList, appliedView, hasMediumScreen }: Props) {
    const contactsRequest = useAppSelector(
        state => state.conversationGrid?.requestStatus || RequestStatus.none,
    );
    const tableRows = useAppSelector(state => state.conversationGrid?.contacts || []);

    return (
        <div className="contactsTable">
            <PageStatus
                showError={contactsRequest === RequestStatus.error}
                showLoading={contactsRequest !== RequestStatus.success}
            >
                <div className="contactsTable__scroller">
                    <div className="contactsTable__header">
                        <ContactsTableHeader
                            columnTemplate={appliedView.properties}
                            hasMediumScreen={hasMediumScreen}
                        />
                    </div>
                    <div className="contactsTable__body">
                        {tableRows.map(aContact => (
                            <ContactsTableRow
                                key={aContact.contactId}
                                contact={aContact}
                                columnTemplate={appliedView.properties}
                                appliedListId={
                                    appliedList.hasOwnProperty('listId')
                                        ? (appliedList as ListItem).listId
                                        : (appliedList as ContactsSegmentsResponse).segmentId
                                }
                                appliedListType={
                                    appliedList.hasOwnProperty('listId')
                                        ? (appliedList as ListItem).type
                                        : 0
                                }
                                hasMediumScreen={hasMediumScreen}
                            />
                        ))}
                    </div>
                </div>
            </PageStatus>
            <div className="contactsTable__footer">
                <TablePagination />
            </div>
        </div>
    );
}
